/* eslint react/display-name: 0 */
import SkeletonPage from './SkeletonPage/SkeletonPage';
import React from 'react';
import CurrentLocale from '../components/CurrentLocale/CurrentLocale';
import _ from 'lodash';

export default (route, ErrorPage) => routeProps => {
    if (process.env.NODE_ENV !== 'production') {
        if (_.get(routeProps, 'match.path') === '*') {
            console.error(`No client side route is defined for this URI: ${_.get(routeProps, 'match.url')}`); // eslint-disable-line
        }
    }

    const {component: Comp, compProps} = route;
    return (
        <React.Fragment>
            <CurrentLocale />
            <SkeletonPage ErrorPage={ErrorPage}>
                <Comp {...compProps} />
            </SkeletonPage>
        </React.Fragment>
    );
};
